/**
 * AlertsNotificationContainer.jsx
 * Created by michaelbray on 10/3/17
 */
import React from 'react';
import AlertsNotification from '../../components/navigation/alerts/AlertsNotification';

import { useFacilityAlerts } from '../../hooks';

export default function(props){
    const alerts = useFacilityAlerts();
    return(
        <AlertsNotification alerts={alerts} {...props} />
    );
}
